export const baseUrl = process.env.REACT_APP_BASE_URL;
export const baseUrlApi = process.env.REACT_APP_API_URL;
export const BaseURLVoyager = process.env.REACT_APP_API_URL_VOYAGER;
export const BaseUrlNewSendero = process.env.REACT_APP_NEW_SENDERO;
export const Recaptcha_key = process.env.REACT_APP_RECAPTCHA_KEY;
export const ViewIvas = process.env.REACT_APP_IVAS;
export const CodigoAgenteLibre = process.env.REACT_APP_AGENTE_LIBRE_CODIGO;
export const CodigoSpotiyfy = process.env.REACT_APP_SPOTIFY;
export const urlIvas = process.env.REACT_APP_LINK_PAGO_RAPIDO_IVA;
